import Obfuscate from "react-obfuscate";
import * as React from 'react';
export default {
  Obfuscate,
  React
};